import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { EmpresaDGI } from './empresas-dgi.model';

// LOAD
export const entityEmpresaDGILoadRequest = createAction(
  '[ENTITYEMPRESADGI] Load Request',
  props<{ rut: string }>()
);

export const entityEmpresaDGILoadFailure = createAction(
  '[ENTITYEMPRESADGI] Load Failure',
  props<{ error: Error }>()
);

export const entityEmpresaDGILoadSuccess = createAction(
  '[ENTITYEMPRESADGI] Load Success',
  props<{ item: EmpresaDGI }>()
);

// SET EMPTY
export const entityEmpresaDGISetEmpty = createAction(
  '[ENTITYEMPRESADGI] Set empty'
);

